import {
    FETCH_DEVICE_INFO_BY_PART_NUMBER_START,
    FETCH_DEVICE_INFO_BY_PART_NUMBER_SUCCESS,
    FETCH_DEVICE_INFO_BY_PART_NUMBER_FAIL
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    deviceInfo: null,
    deviceInfoFetching: false,
    deviceInfoSuccess: false,
    deviceInfoFail: false
};

const deviceInfoFetching = (state) => ({
    ...state,
    deviceInfoFetching: true
});

const deviceInfoFetchFinished = (isSuccess) => (state, action) => ({
    ...state,
    deviceInfo: isSuccess
        ? action.data && action.data.devices && action.data.devices.length > 0 && action.data.devices[0]
        : null,
    deviceInfoFetching: false,
    deviceInfoSuccess: isSuccess,
    deviceInfoFail: !isSuccess
});

export const isDeviceInfoByPartNumberFetching = (state) => state.deviceInfoByPartNumber.deviceInfoFetching;
export const isDeviceInfoSuccess = (state) => state.deviceInfoByPartNumber.deviceInfoSuccess;
export const isDeviceInfoFail = (state) => state.deviceInfoByPartNumber.deviceInfoFail;
export const getDeviceInfo = (state) => state.deviceInfoByPartNumber.deviceInfo;
export const getDeviceInfoByPartNumber = (state) => state.deviceInfoByPartNumber.deviceInfo;

const handlers = {
    [FETCH_DEVICE_INFO_BY_PART_NUMBER_START]: deviceInfoFetching,
    [FETCH_DEVICE_INFO_BY_PART_NUMBER_SUCCESS]: deviceInfoFetchFinished(true),
    [FETCH_DEVICE_INFO_BY_PART_NUMBER_FAIL]: deviceInfoFetchFinished(false)
};

export default function deviceInfo(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
